import createIcon from '../../createIcon';

/**
 * @component @name GeneratingTokens
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA0QzQuNTggNCAxIDcuNTggMSAxMkMxIDE2LjQyIDQuNTggMjAgOSAyMEMxMy40MiAyMCAxNyAxNi40MiAxNyAxMkMxNyA3LjU4IDEzLjQyIDQgOSA0Wk0xMiAxMC41SDEwVjE1LjVIOFYxMC41SDZWOUgxMlYxMC41Wk0yMC4yNSAzLjc1TDIzIDVMMjAuMjUgNi4yNUwxOSA5TDE3Ljc1IDYuMjVMMTUgNUwxNy43NSAzLjc1TDE5IDFMMjAuMjUgMy43NVpNMjAuMjUgMTcuNzVMMjMgMTlMMjAuMjUgMjAuMjVMMTkgMjNMMTcuNzUgMjAuMjVMMTUgMTlMMTcuNzUgMTcuNzVMMTkgMTVMMjAuMjUgMTcuNzVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GeneratingTokens = createIcon('GeneratingTokens', [
  [
    'path',
    {
      d: 'M9 4C4.58 4 1 7.58 1 12C1 16.42 4.58 20 9 20C13.42 20 17 16.42 17 12C17 7.58 13.42 4 9 4ZM12 10.5H10V15.5H8V10.5H6V9H12V10.5ZM20.25 3.75L23 5L20.25 6.25L19 9L17.75 6.25L15 5L17.75 3.75L19 1L20.25 3.75ZM20.25 17.75L23 19L20.25 20.25L19 23L17.75 20.25L15 19L17.75 17.75L19 15L20.25 17.75Z',
      key: '19c94t',
    },
  ],
]);

export default GeneratingTokens;
